import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    root: {},
    hint: {
      color: '#3f505a',
      fontSize: 14,
      fontWeight: 'normal',
      marginBottom: theme.spacing(2),
    },
    progress: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    captcha: {
      maxHeight: 60,
      maxWidth: '100%',
      borderRadius: 4,
      marginInlineStart: theme.spacing(1),
      marginTop: theme.spacing(3),
    },
    submitContainer: {
      paddingTop: theme.spacing(2),
    },
    helpCard: {
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(-2),
      backgroundColor: '#eceff1',
      borderRadius: '4px',
      border: 'solid 1px #cfd8dc',
      boxShadow: 'none',
      marginTop: theme.spacing(1),
    },
    helpContent: {
      paddingBottom: `${theme.spacing(2)} !important`,
    },
    helpTextTitle: {
      fontSize: '13px',
      color: '#003a52',
      fontWeight: 'bold',
    },
    helpTextBody: {
      paddingTop: theme.spacing(1),
      fontSize: '12px',
      color: '#1a334d',
    },
    helpBodyItems: {
      marginTop: theme.spacing(1),
    },
  }));